import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-13" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-14" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-15" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-16" data-mp="fsv9ulhm6hlp">🎁 </span>5 Exklusive Boni
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-17" data-mp="1tvjn9egdunf">
          Gesamtwert <span className="font-bold text-amber-600 line-through" data-id="element-18" data-mp="1wrfms6qq998">€52</span> — Heute{' '}
          <span className="font-bold text-brand" data-id="element-19" data-mp="5tw0t1sxsjy6">GRATIS</span> inkludiert
        </p>

        <ol className="mt-9 space-y-4" data-id="element-20" data-mp="3o3fye0h2f3kw">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-21" data-mp="3t182rtywci5z" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-22" data-mp="1r8a59ku6d1ep">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-36 w-28 shrink-0 object-contain mix-blend-multiply sm:h-40 sm:w-32" data-id="element-23" data-mp="3dg4xot4brwim" />
              <div data-id="element-24" data-mp="3n4mwx5wyhvk5">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-25" data-mp="3n67smyv0bkjl">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] leading-relaxed text-ink/55" data-id="element-26" data-mp="2zhojkh44v3qg">{bonus.text}</p>
                <p className="mt-1.5 text-[11px] font-bold" data-id="element-27" data-mp="2uik9lo9dx1z2">
                  <span className="text-amber-600 line-through" data-id="element-28" data-mp="38hbhuu1kftfa">Wert {bonus.was}</span>{' '}
                  <span className="text-brand" data-id="element-29" data-mp="33gw5a4p3ypyd">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}